module.exports = __webpack_public_path__ + "static/media/Avatar_15.d50ca145.svg";